/** 工具栏可插入的图形种类（与 shapeInsertMenu 一致） */
export type ShapeInsertKind =
  | 'line'
  | 'rect'
  | 'circle'
  | 'triangle'
  | 'polygon'
  | 'heart'
  | 'star';

export const SHAPE_DRAW_DEFAULTS: Record<
  Exclude<ShapeInsertKind, 'line'>,
  { width: number; height: number }
> = {
  /** 单击落盘为正方形；拖拽绘制见 rectBoxFromDrag */
  rect: { width: 100, height: 100 },
  circle: { width: 80, height: 80 },
  triangle: { width: 100, height: 88 },
  polygon: { width: 100, height: 100 },
  heart: { width: 100, height: 100 },
  star: { width: 100, height: 100 },
};

export const LINE_DRAW_DEFAULT = { width: 160, endX: 160, endY: 0 };
